import { IconSun, IconMoonStars } from "@tabler/icons-react";
import {
  useMantineColorScheme,
  useComputedColorScheme,
  Switch,
  rem,
  useMantineTheme,
} from "@mantine/core";

const ThemeToggle = () => {
  const theme = useMantineTheme();
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });

  return (
    <Switch
      size="md"
      color={theme.colors.dark[6]}
      checked={computedColorScheme === "dark"}
      onLabel={
        <IconMoonStars
          style={{ width: rem(18), height: rem(18) }}
          color={theme.colors.blue[6]}
          stroke={2.5}
        />
      }
      offLabel={
        <IconSun
          style={{ width: rem(18), height: rem(18) }}
          color={theme.colors.yellow[6]}
          stroke={2.5}
        />
      }
      styles={{
        thumb: { cursor: "pointer" },
        track: { cursor: "pointer" },
      }}
      onChange={() =>
        setColorScheme(computedColorScheme === "light" ? "dark" : "light")
      }
    />
  );
};

export default ThemeToggle;
